export default "__VITE_ASSET__DydRgkkJ__"